import Units from "../../../utils/Units";
import Time from "../axes/Time";
import Voltage from "../axes/Voltage";

let SoilStickMoisture2 = {
    type: "line",
    label: "Soil Moisture 2 (V)",
    fill: true,
    lineTension: 0,
    colorPalette: 9,
    borderWidth:2,

    pointStyle: "circle",
    pointRadius:0,
    pointHoverRadius: 2,
    pointBorderWidth:.5,
    z:50,

    tooltipLabelValueCallback: (value) => {
        return Units.rounded(value,2);
    },

    yAxis:Voltage,
    xAxis:Time
};

export default SoilStickMoisture2;



// WEBPACK FOOTER //
// ./src/components/chart/channels/SoilStickMoisture2.js